import type { DealUpdateBuyerDataDto, DealUpdateSellerDataDto } from '@dobrozem/sdk';
import { DealService } from '@dobrozem/sdk';
import { useMutation } from '@tanstack/react-query';

import { clientSdk } from '@/lib/sdk';

type DealUserType = 'buyer' | 'seller' | null;

type DealMutationPayload<T> = T extends 'seller'
  ? DealUpdateSellerDataDto
  : T extends 'buyer'
    ? DealUpdateBuyerDataDto
    : never;

interface UseDealMutationProps {
  advertisementId: string;
  dealUserType: DealUserType;
  onSuccess?: (data: any) => void;
}

export const useDealMutation = ({
  advertisementId,
  dealUserType,
  onSuccess,
}: UseDealMutationProps) => {
  const mutationFn = (data: Omit<DealMutationPayload<typeof dealUserType>, 'advertisementId'>) => {
    // Додаємо advertisementId до payload
    const payload = {
      ...data,
      advertisementId,
    };

    if (dealUserType === 'buyer') {
      return DealService.updateBuyerData<false>({
        body: payload as DealUpdateBuyerDataDto,
        client: clientSdk,
      });
    }
    if (dealUserType === 'seller') {
      return DealService.updateSellerData<false>({
        body: payload as DealUpdateSellerDataDto,
        client: clientSdk,
      });
    }
    throw new Error('Invalid dealUserType');
  };

  const mutation = useMutation({
    mutationFn,
    onError: (error) => {
      console.error('Помилка мутації:', error);
    },
    onSuccess: (data) => {
      if (data.error) {
        console.log('Помилка:', data.error);
      } else {
        console.log('Дані успішно оновлено');
        // Викликаємо переданий callback onSuccess
        onSuccess?.(data);
      }
    },
  });

  return mutation;
};
